import BasicState from "src/libs/basic-view"
import ToposForm from "./topos/ToposForm" 

export default class ToposView extends BasicState {
    props: any
    addRender = () => {
        return <ToposForm {...this.props} />  
    }
}